import React, { useEffect, useRef, useState } from 'react';
import { ReactComponent as Logo } from './logo.svg';
import { motion } from 'framer-motion';

const WebGazerComponent = ({ onReady }) => {
  const webgazer = window.webgazer;

  const [gazePoint, setGazePoint] = useState({ x: 0, y: 0 });

  // Guard against React StrictMode double-initialization
  const initRef = useRef(false);
  const rafRef = useRef(null);

  useEffect(() => {
    // Prevent double initialization from React StrictMode
    if (initRef.current) {
      return;
    }
    initRef.current = true;

    webgazer
      .setRegression('ridge')
      .showPredictionPoints(false)
      .begin()
      .then(() => {
        webgazer.setVideoViewerSize(85, 75);

        const checkWebGazerReady = () => {
          const ready = webgazer.isReady();
          if (ready) {
            onReady(true);

            const refreshGazePoint = () => {
              webgazer.getCurrentPrediction()
                .then(prediction => {
                  if (prediction) {
                    setGazePoint({ x: prediction.x, y: prediction.y });
                  } else {
                    setGazePoint(null);
                  }
                  rafRef.current = requestAnimationFrame(refreshGazePoint);
                })
                .catch(err => {
                  console.error('[WebGazer] getCurrentPrediction error:', err);
                  rafRef.current = requestAnimationFrame(refreshGazePoint);
                });
            };
            refreshGazePoint();
          } else {
            setTimeout(checkWebGazerReady, 1000);
          }
        };

        checkWebGazerReady();
      })
      .catch((err) => {
        console.error('[WebGazer] Failed to initialize:', err);
        initRef.current = false;
      });

    // Cleanup on unmount
    return () => {
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current);
      }
    };
  }, []);

  return (
    <div style={{ position: 'relative' }}>
    {gazePoint && (
      <motion.div
        initial={{ opacity: 0, x: gazePoint.x, y: gazePoint.y }}
        animate={{ opacity: 1, x: gazePoint.x, y: gazePoint.y }}
        transition={{ type: 'easeOut', duration: 0.1 }}
        style={{ position: 'absolute' }}
      >
        <Logo style={{width: '18px', height: '18px'}} />
      </motion.div>
      )}
    </div>
  );
};

export default WebGazerComponent;
